module.exports = __webpack_public_path__ + "img/impostor-silhouete-bg-1.0e07251e.png";